import { render } from "./receiveBonus.vue?vue&type=template&id=dd82b69c&scoped=true"
import script from "./receiveBonus.vue?vue&type=script&lang=js"
export * from "./receiveBonus.vue?vue&type=script&lang=js"

import "./receiveBonus.vue?vue&type=style&index=0&id=dd82b69c&scoped=true&lang=css"
import "./receiveBonus.vue?vue&type=style&index=1&id=dd82b69c&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd82b69c"]])

export default __exports__